import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import isValidHTML from 'is-html';
import { size } from "../../../utils/size";
import { HOME_HIGHLIGHTS, VIEW_MORE } from "../../../utils/default-strings";
import { buildKeyFromStrings } from "../../../utils/build-key-from-strings";
import { Grid } from "../../layout/Grid";
import { GridColumn } from "../../layout/GridColumn";
import { Heading } from "../../typography/Heading";
import { Icon } from "../../elements/Icon";
import { Subheading } from "../../typography/Subheading";
import { MultiParagraph } from "../../typography/MultiParagraph";
import { Characteristics } from "../../collections/Characteristics";
export var Component = function Component(_ref) {
  var id = _ref.id,
      descriptionText = _ref.descriptionText,
      extraDescriptionButtonText = _ref.extraDescriptionButtonText,
      homeHighlights = _ref.homeHighlights,
      homeHighlightsHeadingText = _ref.homeHighlightsHeadingText,
      mainCharacteristics = _ref.mainCharacteristics,
      propertyName = _ref.propertyName,
      propertyType = _ref.propertyType;
  return React.createElement(Grid, {
    columns: 1,
    id: id
  }, React.createElement(GridColumn, {
    width: 12
  }, React.createElement(Subheading, null, propertyType), React.createElement(Heading, {
    size: "large"
  }, propertyName)), !!size(mainCharacteristics) && React.createElement(Characteristics, {
    spaceCharacteristics: mainCharacteristics
  }), descriptionText && React.createElement(GridColumn, {
    width: 12
  }, React.createElement(MultiParagraph, {
    content: descriptionText,
    isHtml: isValidHTML(descriptionText),
    showMoreLabel: extraDescriptionButtonText
  })), size(homeHighlights) > 0 && React.createElement(Fragment, null, React.createElement(GridColumn, {
    width: 12
  }, React.createElement(Subheading, null, homeHighlightsHeadingText)), React.createElement(GridColumn, {
    width: 12
  }, homeHighlights.map(function (_ref2) {
    var iconName = _ref2.iconName,
        text = _ref2.text;
    return React.createElement(Icon, {
      hasBorder: true,
      key: buildKeyFromStrings(text),
      labelText: text,
      name: iconName
    });
  }))));
};
Component.displayName = 'Description';
Component.defaultProps = {
  id: null,
  descriptionText: null,
  homeHighlightsHeadingText: HOME_HIGHLIGHTS,
  mainCharacteristics: [],
  extraDescriptionButtonText: VIEW_MORE
};
Component.propTypes = process.env.NODE_ENV !== "production" ? {
  descriptionText: PropTypes.string,
  extraDescriptionButtonText: PropTypes.string,
  homeHighlights: PropTypes.arrayOf(PropTypes.shape({
    iconName: PropTypes.string,
    text: PropTypes.string.isRequired
  })).isRequired,
  homeHighlightsHeadingText: PropTypes.string,
  id: PropTypes.string,
  mainCharacteristics: PropTypes.arrayOf(PropTypes.shape({
    iconName: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired
  })),
  propertyName: PropTypes.string.isRequired,
  propertyType: PropTypes.string.isRequired
} : {};